module.exports = __webpack_public_path__ + "assets/img/myroomsimulation.de23b0ad.svg";